import { render, staticRenderFns } from "./AMEmptinessPhonecase18Pro.vue?vue&type=template&id=1201f246&scoped=true"
import script from "./AMEmptinessPhonecase18Pro.vue?vue&type=script&lang=ts"
export * from "./AMEmptinessPhonecase18Pro.vue?vue&type=script&lang=ts"
import style0 from "../assets/styles/pages/am-emptiness-phonecase-iphone18-pro.scss?vue&type=style&index=0&id=1201f246&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1201f246",
  null
  
)

export default component.exports